import React from 'react';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';

const componentName = "ShiftByDay";

const Header = (props) => (
    <div className="row row_margin_none">
        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <DatePickerInput
                name={componentName + LOOKUP.report.common.beginDate.name}
                floatingLabelText={LOOKUP.report.common.beginDate.label}
                hintText={LOOKUP.report.common.beginDate.label}
                fullWidth={true}
            />
        </div> {/* .col */}
        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <DatePickerInput
                name={componentName + LOOKUP.report.common.endDate.name}
                floatingLabelText={LOOKUP.report.common.endDate.label}
                hintText={LOOKUP.report.common.endDate.label}
                fullWidth={true}
            />
        </div> {/* .col */}
        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <BranchSelectAutoCompleteInput
                name={componentName + LOOKUP.report.common.branchName}
                fullWidth={true}
                label={LOOKUP.report.common.branch}
                floatingLabelText={LOOKUP.report.common.branch}
                hintText={LOOKUP.report.common.branch}
                options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
            />
        </div> {/* .col */}
        <Button
            className="pull-right mt-2 ml-1 report_btn"
            mini={true}
            name={componentName + LOOKUP.report.common.viewReport.name}
            label={LOOKUP.report.common.viewReport.label}
            primary={true}
            onTouchTap={props.filter}
        />
    </div>
);

export default Header;


